export default __webpack_public_path__ + "static/media/O-127.bdb0d8c2.png";